module.exports = __webpack_public_path__ + "static/img/1569_phase_function_Paper_Points.a6da01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1569_phase_function_Paper_Points.png
// module id = h7ce
// module chunks = 0